<template>
  <TitlePage
    class="page-edit-case"
    :title="lang.title"
    @back="$emit('back')"
    @commit="commit"
  >
    <div class="page-edit-case-container">
      <div v-for="(row, i) in input" :key="i"
        v-if="row.type==='media'"
        class="page-edit-case-media">
        <div class="page-edit-case-media-control">
          <IconButton v-if="i > 0" @click="moveUp(row, i)" class="icon-dc_phone_icon_email_up"></IconButton>
          <IconButton v-if="i < input.length - 1" @click="moveDown(row, i)" class="icon-pr_phone_arrow_edit_open"></IconButton>
          <IconButton @click="remove(row, i)" class="icon-dc_phone_icon_email_delete"></IconButton>
        </div>
        <div class="page-edit-case-media-block">
          <UploadButton class="upload"
            @click="upload(row, i)" :src="row.img || row.imgForAvatar"></UploadButton>
          <input
            :id="`page-edit-case-media-upload-${i}`"
            class="invisible" type="file" accept="*/*"
            :data-index="i"
            @change="updateImg">
        </div>
        <div class="page-edit-case-media-block">
          <div class="title">
            <span class="red">*</span>项目名称
          </div>
          <div class="name">
            <BaseInput v-model.trim="row.name"></BaseInput>
          </div>
        </div>
        <div class="page-edit-case-media-block">
          <div class="title">
            <span class="red">*</span>行业
          </div>
          <div class="industry">
            <BaseInput
              v-model.trim="row.label"
              :placeholder="lang.industry"
              icon="icon-pr_phone_arrow_edit_open" iconFloat="right"
              @icon="clickDesc(i)"
            ></BaseInput>
          </div>
        </div>
        <div class="page-edit-case-media-block">
          <div class="title">项目描述</div>
          <div class="desc">
            <textarea
              class="textarea"
              v-model.trim="row.value"
            ></textarea>
          </div>
        </div>
      </div>
      <div class="page-edit-case-create-cap"></div>
    </div>
    <BaseButton1 @click="create" class="page-edit-case-create">新增案例</BaseButton1>
  </TitlePage>
</template>

<script>
import _ from 'lodash'

import Store from '@/Store.js'
import {
  dcV2Graphql
} from '@/api'

import weui from 'weui.js'
import TitlePage from './TitlePage.vue'

import { BaseInput } from '../input'
import {
  BaseButton1,
  IconButton,
  UploadButton
} from '../button'

export default {
  components: {
    TitlePage,
    BaseInput,
    BaseButton1,
    IconButton,
    UploadButton
  },
  props: {
    data: {
      type: Object,
      required: true
    },
    config: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      lang: {
        title: `编辑${this.data.name}`,
        industry: '选择或输入项目所属行业'
      },
      input: _.cloneDeep(this.data.value),
      defaultData: {
        type: 'media',
        name: '',
        value: '',
        label: ''
      },
      currentIndex: -1
    }
  },
  computed: {
    dataTagForSelect () {
      return this.config.industry.map(row => {
        return row.label
      })
    }
  },
  methods: {
    clickDesc (i) {
      weui.picker(this.dataTagForSelect, {
        defaultValue: [this.input[i].label],
        className: 'weui picker',
        onChange: result => {
        },
        onConfirm: result => {
          this.input[i].label = result[0].value
        },
        id: 'clickDesc'
      })
    },
    /**
     * 上传图片相关
     */
    upload (row, i) {
      document.getElementById(`page-edit-case-media-upload-${i}`).click()
    },
    async updateImg (event) {
      let oFile = event.target.files[0]
      if (!oFile || !oFile.type) {
        throw new Error('请选择正确格式')
      }
      let mb = 10
      let iMaxFilesize = 1048576 * mb
      if (oFile.size > iMaxFilesize) {
        throw new Error(`档案尺寸超出 ${mb}MB 上限`)
      }
      // let formData = new FormData()
      // formData.append('ranch.deliver.attachment', oFile)
      // let res = await ranch.post('/tephra/ctrl-http/upload', formData)
      // if (_.get(res, 'data[0].success') !== true) {
      //   let msg = _.get(res, 'data[0].message', 'upload failed')
      //   throw new Error(msg)
      // }
      let formdata = new FormData()
      formdata.append('file', oFile)
      formdata.append('query', `mutation { createUserImage { id, url, width, height } }`)
      let res = await dcV2Graphql.post('', formdata, {
        headers: {
          'tephra-session-id': Store.get('sid')
        }
      })
      let i = parseInt(event.target.getAttribute('data-index'))
      this.input[i].logo = _.get(res, 'data.data.createUserImage')
      this.input[i].img = this.input[i].logo.url
      this.input[i].imgFile = oFile
      let reader = new FileReader()
      reader.onload = e => {
        this.input[i].imgForAvatar = e.target.result
        this.input.splice(i, 1, this.input[i])
      }
      reader.readAsDataURL(oFile)
    },
    close () { this.$emit('close') },
    commit () { this.$emit('commit', this.input) },
    create () {
      this.input.unshift(_.cloneDeep(this.defaultData))
    },
    remove (row, i) {
      this.input.splice(i, 1)
    },
    move (fromIndex, toIndex) {
      let row = this.input.splice(fromIndex, 1)[0]
      this.input.splice(toIndex, 0, row)
    },
    moveUp (row, i) {
      this.move(i, i - 1)
    },
    moveDown (row, i) {
      this.move(i, i + 1)
    }
  }
}
</script>

<style lang="postcss" scoped>
@import "index.css";
.page-edit-case {
  & .page-edit-case-create-cap {
    height: 10%;
  }
  & .page-edit-case-create {
    position: absolute;
    margin: 0 10%;
    width: 80%;
    bottom: 40px;
  }
  & .page-edit-case-container {
    position: absolute;
    width: 100%;
    bottom: 0;

    overflow: auto;

    @media (--mediaPc) {
      top: 88px;
    }
    @media (--mediaMobile) {
      top: calc(88px / var(--scaleMobile));
    }
    & .page-edit-case-media {
      position: relative;
      @media (--mediaPc) {
        margin: 0 56px;
        padding: 56px 0;
      }
      @media (--mediaMobile) {
        margin: 0 calc(56px / var(--scaleMobile));
        padding: calc(56px / var(--scaleMobile)) 0;
      }
      & .page-edit-case-media-block {
        position: relative;
        width: 100%;

        @media (--mediaPc) {
          padding: calc(50px / 2) 0;
        }
        @media (--mediaMobile) {
          padding: calc(50px / var(--scaleMobile) / 2) 0;
        }
        & .upload {
          width: 100%;
          display: inline-block;
          @media (--mediaPc) {
            height: 320px;
          }
          @media (--mediaMobile) {
            height: calc(320px / var(--scaleMobile));
          }
        }
        & .title {
          @media (--mediaPc) {
            padding-bottom: 20px;
            font-size: var(--textSize3);
          }
          @media (--mediaMobile) {
            padding-bottom: calc(20px / var(--scaleMobile));
            font-size: var(--textSize3Mobile);
          }
        }
        & .name {
          width: 100%;
          @media (--mediaPc) {
            padding-bottom: 20px;
            font-size: var(--textSize3);
          }
          @media (--mediaMobile) {
            padding-bottom: calc(20px / var(--scaleMobile));
            font-size: var(--textSize3Mobile);
          }
        }
        & .industry {
          width: 100%;
          @media (--mediaPc) {
            font-size: var(--textSize3);
          }
          @media (--mediaMobile) {
            font-size: var(--textSize3Mobile);
          }
        }
        & .desc {
          position: relative;
          box-sizing: border-box;
          width: 100%;
          border: 1px solid var(--colorDisabled);

          @media (--mediaPc) {
            height: 200px;
            padding: 35px 40px;
          }
          @media (--mediaMobile) {
            height: calc(200px / var(--scaleMobile));
            padding: calc(35px / var(--scaleMobile)) calc(40px / var(--scaleMobile));
          }
          & .textarea {
            resize: none;
            position: relative;
            outline: none;
            height: 100%;
            width: 100%;
            padding: 0;
            border: 0;
            @media (--mediaPc) {
              font-size: var(--textSize3);
            }
            @media (--mediaMobile) {
              font-size: var(--textSize3Mobile);
            }
          }
        }
        & .red {
          color: var(--colorError);
        }
      }
      & .page-edit-case-media-control {
        text-align: right;

        @media (--mediaPc) {
          padding: 20px 0;
        }
        @media (--mediaMobile) {
          padding: calc(20px / var(--scaleMobile)) 0;
        }
        & .page-edit-case-media-control-icon {
          @media (--mediaPc) {
            height: 50px;
            width: 50px;
          }
          @media (--mediaMobile) {
            height: calc(50px / var(--scaleMobile));
            width: calc(50px / var(--scaleMobile));
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/page/EditCasePage.vue